// ----------------------------------------------------------------------------
// -------------------------------------------------------------------- Imports
// ----------------------------------------------------------------------------
import React from "react";
import PropTypes from "prop-types";
import Helmet from "react-helmet";

// ----------------------------------------------------------------------------
// ------------------------------------------------------------------ Component
// ----------------------------------------------------------------------------
/**
  * WebsiteSchema - Implements schema.org Website
  *
  * Describes a webpage
  *
  * @example
    <WebsiteSchema data={data}>
  *
  * @param {string} data.url - Required. The url of the page.
  * @param {string} data.name - Required. Name / Title of the page.
  * @param {string} data.description - Required. A short summary of the content on the webpage.
  * @param {string} data.author - Required. An individual who has authored the webpage.
  * @param {string} data.publisher - Required. An organisation that owns the rights to the webpage.
  * @param {string} data.image - Required. A unique banner image.
  *
  * @version 0.0.1
  * @todo none
  * @see {@link http://schema.org/WebSite|Schema.org Webpage Docs}
  */
var WebsiteSchema = function WebsiteSchema(props) {
  var data = props.data;


  var sanitized = data.url;
  if (sanitized.endsWith("/")) {
    sanitized = sanitized.substring(0, sanitized.length - 1);
  }

  var schemaOrgJSONLD = {
    "@context": "http://schema.org",
    "@type": "WebSite",
    url: sanitized,
    name: data.name,
    image: data.image,
    description: data.description,
    author: {
      "@type": "Person",
      name: data.author
    },
    publisher: {
      "@type": "Organization",
      name: data.publisher
    }
  };
  // console.log(JSON.stringify(schemaOrgJSONLD));

  return React.createElement(
    Helmet,
    null,
    React.createElement(
      "script",
      { type: "application/ld+json" },
      JSON.stringify(schemaOrgJSONLD)
    )
  );
};

WebsiteSchema.propTypes = process.env.NODE_ENV !== "production" ? {
  data: PropTypes.object // eslint-disable-line react/forbid-prop-types
} : {};

WebsiteSchema.defaultProps = {
  data: {
    author: ""
  }
};

// ----------------------------------------------------------------------------
// --------------------------------------------------------------------- Export
// ----------------------------------------------------------------------------
export default WebsiteSchema;